import { Button } from "@/components/design-system/button";
import CourseBuilderForm from "@/modules/Course-Management/components/course-builder/CourseBuilderForm";
import { createCourseService } from "@/service/course.service";
import type { CreateCoursePayload } from "@/types/course.model";
import { successToast } from "@/utils/constants";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function CreateCourse() {
  const navigate = useNavigate();

  const handleSave = async (payload: CreateCoursePayload) => {
    try {
      await createCourseService(payload);
      if (payload.is_published) {
        successToast("Course created", "The course was saved successfully.");
      } else {
        successToast("Draft saved", "The course was saved as draft.");
      }
      navigate("/course-management");
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="h-full flex flex-col">
      <div className="h-[68px] px-[32px] items-center flex justify-between gap-4">
        <div className="flex items-center gap-3">
          <Button
            type="button"
            variant="light"
            size="md"
            className="w-[40px] h-[40px] p-0 bg-white border border-[#EDEDED] rounded-[8px]"
            onClick={() => navigate(-1)}
            leftIcon={<ChevronLeft className="w-5 h-5" />}
          >
            <span className="sr-only">Back</span>
          </Button>
          <div className="text-[#1F1F1F] text-[16px] font-semibold">
            Create Course
          </div>
        </div>
      </div>

      <div className="flex-1 px-[32px] pb-[24px]">
        <CourseBuilderForm
          mode="create"
          onSubmit={handleSave}
          onClose={() => navigate(-1)}
        />
      </div>
    </div>
  );
}
